import { Center, Spinner } from "@givenwell/components";
import { PageWrapper } from "./PageWrapper";

/**
 * Default `pendingComponent` for the direct child routes of the admin,
 * supplier, and supporter layouts. Renders a centered spinner inside a
 * PageWrapper so the page chrome stays consistent while a route loads.
 */
export function PagePending() {
  return (
    <PageWrapper>
      <Center css={{ flex: "1 0 0px" }}>
        <Spinner />
      </Center>
    </PageWrapper>
  );
}
